The total number of statuses in the process.
